import {Pipe, PipeTransform} from '@angular/core';
import {AppointmentStatusEnum} from '../../models/appointment';

@Pipe({
  name: 'setAppointmentStatusColor'
})
export class SetAppointmentStatusColorPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): string {
    let color = '';
    switch (value) {
      case AppointmentStatusEnum.CANCELLED:
        color = '#FC427B';
        break;
      case AppointmentStatusEnum.COMPLETED:
        color = '#3dc1d3';
        break;
      case AppointmentStatusEnum.SCHEDULED:
        color = '#778beb';
        break;
      case AppointmentStatusEnum.TO_RESCHEDULE:
        color = '#f3a683';
        break;
      case AppointmentStatusEnum.CONFIRMED:
        color = '#786fa6';
        break;
      case AppointmentStatusEnum.TO_CONFIRM:
        color = '#cf6a87';
        break;
    }
    return color;
  }

}
